
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "signedNumber",
    standalone: true
})
export class SignedNumberPipe implements PipeTransform {
    public transform(value: number, precision: number = 2): string {
        const formatted = Math.abs(value).toFixed(precision);
        return value >= 0 ? `+${formatted}` : `-${formatted}`;
    }
}